module.exports = __webpack_public_path__ + "static/img/分类图片2@3x.040495e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/分类/分类图片2@3x.png
// module id = /f0g
// module chunks = 192